import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import GeodeticDatumForm from '../Forms/GeodeticDatumForm';

const AddEditGeodeticDatumModal = ({
	dataGeodeticDatum,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Dato Geodésico
			</ModalHeader>

			<GeodeticDatumForm
				dataGeodeticDatum={dataGeodeticDatum}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditGeodeticDatumModal;
